<template>
  <div>
    <transition name="modal-fade">
      <div v-if="display" class="modal-overlay" @click="hideModal"></div>
    </transition>
    <transition name="modal-fade">
      <div v-if="display" class="modal-content">
        <slot>
          <div>Modal Placeholder</div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "DialogModal",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      display: false,
    };
  },
  methods: {
    showModal: function() {
      this.display = true;
    },
    hideModal: function() {
      this.display = false;
    }
  }
});
</script>

<style lang="postcss" scoped>
.modal-overlay {
  @apply fixed h-screen w-screen min-h-screen top-0 left-0;
  background: rgba(0, 0, 0, 0.6);
}
.modal-content {
  @apply fixed rounded-lg bg-white w-4/5 opacity-100 pt-5;
  height: 60%;
  left: 10%;
  top: 20%;
  overflow-y: scroll;
  -ms-overflow-style: none;
}

.modal-content::-webkit-scrollbar {
  display: none;
}
</style>

<style scoped>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
